export const useUnitConversion = () => {

    // create a function that takes a unit and a value
    // if the unit is not one of the four valid units, return an empty string
    // if the unit is valid, return the string with the original value and the converted value
    // with the appropriate unit and use a / to separate the two values
    // example:  5.5 in / 140 mm
    // example:  5.5 F / 13.0 C
    function convert(unit: string, value: number, precision = 1) {
        if (value === undefined) return ''
        value = Number(value)
        if (unit === 'in') {
            const mm = value * 25.4
            return `${Number(value).toFixed(precision)} in / ${mm.toFixed(precision)} mm`
        } else if (unit === 'mm') {
            const inches = value / 25.4
            return `${value.toFixed(precision)} mm / ${inches.toFixed(precision)} in`
        } else if (unit === 'F') {
            const celsius = (value - 32) * 5/9
            return `${value.toFixed(precision)}&deg;F (${celsius.toFixed(precision)}&deg;C)`
        } else if (unit === 'C') {
            const fahrenheit = (value * 9/5) + 32
            return `${value.toFixed(precision)}&deg;C (${fahrenheit.toFixed(precision)}&deg;F)`
        } else {
            return ''
        }
    }

    // create a function that will take an input and output unit a value and precision
    // and return a number with the output value. The precision is the number of decimal places to display
    // precision defaults to 1
    // the conversion to support is:
    // in to mm
    // mm to in
    // F to C
    // C to F
    function convertValue(inputUnit: string, outputUnit: string, value: number, precision = 1) {
        if (value === undefined) return ''
        if (inputUnit === outputUnit) {
            return value.toFixed(precision)
        }

        if (inputUnit === 'in' && outputUnit === 'mm') {
            return (value * 25.4).toFixed(precision)
        } else if (inputUnit === 'mm' && outputUnit === 'in') {
            return (value / 25.4).toFixed(precision)
        } else if (inputUnit === 'F' && outputUnit === 'C') {
            return ((value - 32) * 5/9).toFixed(precision)
        } else if (inputUnit === 'C' && outputUnit === 'F') {
            return ((value * 9/5) + 32).toFixed(precision)
        } else {
            return value.toFixed(precision)
        }
    }

    return { convert, convertValue }



}

